module.exports = __webpack_public_path__ + "static/img/health_card_bg.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/health_card_bg.png
// module id = 550
// module chunks = 0